import React from 'react'
import remera from '../../assets/Store/remera.jpg'

export const Jerseys = () => {

  return (

    <div className='container jerseys'>
                  <a href="/Jerseys">
                <div className="card card-store" style={{width: '18rem', backgroundColor:'#2C2C2C', border:'none'}}>
                    <img src={remera} className="card-img-top" alt="..." style={{height:'250px', objectFit:'contain', borderRadius:'10px'}}/>
                    <div className="card-body">
                    <p className="card-text" style={{color:'whitesmoke'}}>Remera</p>
                        <span className='price-jersey' style={{color:'whitesmoke'}}>$10.000</span>                    
                        </div>
                </div>
            </a>

            <a href="#">
                <div className="card card-store" style={{width: '18rem', backgroundColor:'#2C2C2C', border:'none'}}>
                    <img src={remera} className="card-img-top" alt="..." style={{height:'250px', objectFit:'contain', borderRadius:'10px'}}/>
                    <div className="card-body">
                    <p className="card-text" style={{color:'whitesmoke'}}>Remera</p>
                        <span className='price-jersey' style={{color:'whitesmoke'}}>$10.000</span>                    
                        </div>
                </div>
            </a>

            <a href="#">
                <div className="card card-store" style={{width: '18rem', backgroundColor:'#2C2C2C', border:'none'}}>
                    <img src={remera} className="card-img-top" alt="..." style={{height:'250px', objectFit:'contain', borderRadius:'10px'}}/>
                    <div className="card-body">
                        <p className="card-text" style={{color:'whitesmoke'}}>Remera</p>
                        <span className='price-jersey' style={{color:'whitesmoke'}}>$10.000</span>
                    </div>
                </div>
            </a>

            <a href="#">
                <div className="card card-store" style={{width: '18rem', backgroundColor:'#2C2C2C', border:'none'}}>
                    <img src={remera} className="card-img-top" alt="..." style={{height:'250px', objectFit:'contain', borderRadius:'10px'}}/>
                    <div className="card-body">
                    <p className="card-text" style={{color:'whitesmoke'}}>Remera</p>
                        <span className='price-jersey' style={{color:'whitesmoke'}}>$10.000</span>                    
                        </div>
                </div>
            </a>


            <a href="#">
                <div className="card card-store" style={{width: '18rem', backgroundColor:'#2C2C2C', border:'none'}}>
                    <img src={remera} className="card-img-top" alt="..." style={{height:'250px', objectFit:'contain', borderRadius:'10px'}}/>
                    <div className="card-body">
                    <p className="card-text" style={{color:'whitesmoke'}}>Remera</p>
                        <span className='price-jersey' style={{color:'whitesmoke'}}>$10.000</span>                    
                        </div>
                </div>
            </a>

            <a href="#">
                <div className="card card-store" style={{width: '18rem', backgroundColor:'#2C2C2C', border:'none'}}>
                    <img src={remera} className="card-img-top" alt="..." style={{height:'250px', objectFit:'contain', borderRadius:'10px'}}/>
                    <div className="card-body">
                    <p className="card-text" style={{color:'whitesmoke'}}>Remera</p>
                        <span className='price-jersey' style={{color:'whitesmoke'}}>$10.000</span>
                        </div>
                </div>
            </a>
    </div>
  )
}
